import React from 'react';
import {Link} from 'react-router-dom';
import AurAlertCarousel from '../../../common/aur-alert/AurAlertCarousel';

const Alerts: React.FC = () => {
  const datasets = [
    '1EM001',
    '1EM002',
    '1EM003',
    '1EM004',
    '1EM005',
    '1EM006',
    '1EM007',
    '1EM008',
    '1EM009',
    '1EM010',
    '1EM011',
    '1EM012',
    '1EM013',
    '1EM014',
    '1EM015',
    '1EM016',
  ];
  const alertsData1 = [
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
  ];
  const alertsData2 = [
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: false,
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: false,
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: false,
      datasets: datasets,
    },
  ];
  const alertsData3 = [
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: false,
      showArrowCTA: false,
      workspaceName: 'WorkspaceName',
    },
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription:
        'Description lorem ipsum dolor sit amet, conse adipiscing elit, sed do eiusmod. Description lorem ipsum dolor sit amet, consectetur adipiscing.',
      showDatasets: false,
      showArrowCTA: false,
      workspaceName: 'WorkspaceName',
    },
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: false,
      showArrowCTA: false,
      workspaceName: 'WorkspaceName',
    },
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: false,
      showArrowCTA: false,
      workspaceName: 'WorkspaceName',
    },
  ];
  const alertsData4 = [
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription:
        'Description lorem ipsum dolor sit amet, conse adipiscing elit, sed do eiusmod. Description lorem ipsum dolor sit amet, consectetur adipiscing.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription:
        'Description lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription:
        'Description lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.t',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription:
        'Description lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription:
        'Description lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
  ];
  const alertsData5 = [
    {
      alertTitle: 'Alert Title 1',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription:
        'Description lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 2',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription:
        'Description lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 3',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 4',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 5',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 6',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName 7',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 7',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 8',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 9',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
  ];
  const alertsData6 = [
    {
      alertTitle: 'Alert Title 1',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription:
        'Description lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 2',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription:
        'Description lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 3',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 4',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 5',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 6',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName 7',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 7',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 8',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 9',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 10',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 11',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 12',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 13',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 14',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
    {
      alertTitle: 'Alert Title 15',
      triggeredOn: '2024-10-28T00:54:24.86',
      alertDescription: 'Description lorem ipsum dolor sit amet.',
      showDatasets: true,
      showArrowCTA: true,
      projectName: 'ProjectName',
      workspaceName: 'WorkspaceName',
      datasets: datasets,
    },
  ];
  return (
    <div style={{backgroundColor: '#1F2B3D', paddingLeft: '25px'}}>
      <div style={{marginBottom: '64px'}}>
        <h1>Alerts</h1>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <h2>Welcome Screen Alert</h2>
          <h4>View for 2 Alerts</h4>
          <AurAlertCarousel alertsData={alertsData1} />
        </div>
        <div style={{marginBottom: '32px'}}>
          <h2>Workspace level on welcome screen</h2>

          <h4>View for 3 Alerts</h4>
          <AurAlertCarousel alertsData={alertsData2} />
        </div>
        <div style={{marginBottom: '32px'}}>
          <h2>Report level Alert</h2>
          <h4>View for 4 Alerts</h4>
          <AurAlertCarousel alertsData={alertsData3} />
        </div>
        <div style={{marginBottom: '32px'}}>
          <h2>Example Carousel - Responsive Height</h2>
          <h4>View for 6 Alerts</h4>
          <AurAlertCarousel alertsData={alertsData4} />
        </div>
        <div style={{marginBottom: '32px'}}>
          <h4>View for 9 Alerts</h4>
          <AurAlertCarousel alertsData={alertsData5} />
        </div>
        <div style={{marginBottom: '32px'}}>
          <h4>View for 15 Alerts</h4>
          <AurAlertCarousel alertsData={alertsData6} />
        </div>
      </div>
    </div>
  );
};

export default Alerts;
